import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import NotFoundView from './components/404.vue'

import Inicio from './components/views/Inicio.vue'
import AplicationView from './components/views/Aplication.vue'
import OperacionesView from './components/views/Operaciones.vue'
import TrabajadoresView from './components/views/Trabajadores.vue'
import UsuariosView from './components/views/Usuarios.vue'
import UsuariosCas from './components/views/UsuariosCas.vue'
import UsuariosAuth from './components/views/UsuariosAuth.vue'
import RolesView from './components/views/Roles.vue'
import AreasView from './components/views/Areas.vue'
import Aplication_Detalle from './components/views/Aplication_Detalle.vue'
import Area_Detalle from './components/views/Area_Detalle.vue'
import Rol_Detalle from './components/views/Rol_Detalle.vue'
import PensionistasView from './components/views/Pensionistas.vue'
import ExTrabajadoresView from './components/views/ExTrabajadores.vue'

const routes = [
  {
    path: '/login',
    component: LoginView
  },
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: '/home',
        alias: '',
        component: Inicio,
        name: 'Inicio',
      }, 
      {
        // path: '/aplication',
        path: '/aplicaciones',
        component: AplicationView,
        name: 'aplicaciones'
      }, 
      {
        path: '/operaciones',
        alias: '',
        component: OperacionesView,
        name: 'operaciones'
      },
      {
        // path: '/trabajadores',
        path: '/personal',
        alias: '',
        component: TrabajadoresView,
        name: 'trabajadores',
      },
      {
        path: '/roles',
        alias: '',
        component: RolesView,
        name: 'roles'
      },
      {
        path: '/areas',
        alias: '',
        component: AreasView,
        name: 'areas'
      },
      {
        path: '/usuariosCas',
        alias: '',
        component: UsuariosCas,
        name: 'Usuarios CAS'
      }, 
      {
        path: '/usuariosAuth',
        alias: '',
        component: UsuariosAuth,
        name: 'Usuarios Auth0'
      }, 
      {
        path: '/home',
        alias: '',
        component: Inicio,
        name: 'panel'
      }, 
      {
        // path: '/:idTrab',
        //path: '/personal/:idTrab',
        path: '/personal_detalle',
        // alias: '',
        component: UsuariosView,
        name: 'usuarios'
        //props: true
      },
      {        
        // path: '/:idApp',
        // path: '/aplicaciones/:idApp',
        path: '/aplicaciones_detalle',
        // alias: '',
        component: Aplication_Detalle,
        name: 'aplicaciones_detalle'
        //props: true
      },
      {
        // path: ':idArea',
        //path: '/areas/:idArea', 
        path: '/areas_detalle', 
        name: 'area_detalle',
        component: Area_Detalle
        //props: true
      },
      {
        // path: ':idRol',
        //path: '/roles/:idRol',
        path: '/roles_detalle',
        name: 'rol_detalle',
        component: Rol_Detalle
        //props: true
      },
      {
        // path: '/firmantes',
        path: '/pensionistas',
        alias: '',
        component: PensionistasView,
        name: 'pensionistas'
      },
      {
        // path: '/configuracion',
        path: '/extrabajadores',
        alias: '',
        component: ExTrabajadoresView,
        name: 'extrabajadores'
      }
    ]
  }, {
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js